<template>
  <div class=" key-information-card"  v-masonry-tile >
    <div class="key-information-card-inner">
        <div>
        <img class="main-image" :src="`${$store.state.clientConfig.directoryUrl}/img/${schemeDoc.image}`" v-if="schemeDoc.image !== undefined && schemeDoc.image!== ''" :alt="`Image for ${schemeDoc.title}`"/>
        <key-information-video-thumbnail v-if="schemeDoc.videoUrl" :schemeDoc="schemeDoc" @videoModal="videoModal" />
        <div class="card-body" :style="style"  :class="{'no-snippet': !showSnippet}">
        <div class="icon-round" v-if="schemeDoc.tileIconImage === undefined || schemeDoc.tileIconImage === ''"><span :class="`icon-${schemeDoc.tileIcon}`" class="icon"></span></div>
        <div class="tile-icon-image"  v-if="schemeDoc.tileIconImage" >
          <img :src="schemeDoc.tileIconImage" />
        </div>
        <h1 v-if="showSnippet" class="key-fund-heading inline">{{ schemeDoc.title }}
            <div class="divider" />
        </h1>
        <div v-if="showSnippet" class="key-fund-content" v-html="schemeDoc.snippet"></div>
        </div>
        </div>
      <div class="card-links" v-if="schemeDoc.links && schemeDoc.links.length > 0">
          <div class="links-item link" :class="{separator: linkIndex !== links.length - 1}" v-for="(linkDetails, linkIndex ) in links" :key="linkIndex"
           @click="linkTo(`${$store.state.clientConfig.directoryUrl}/documents/${linkDetails.downloadUrl}`, false)"
            @keyup.enter="linkTo(`${$store.state.clientConfig.directoryUrl}/documents/${linkDetails.downloadUrl}`, false)"
            @keyup.space="linkTo(`${$store.state.clientConfig.directoryUrl}/documents/${linkDetails.downloadUrl}`, false)"
            tabindex="0"
            role="link"
            :aria-label="linkDetails.text">
            <font-awesome-icon :icon="['fal', 'file-pdf']"/> <span>{{linkDetails.text}}</span>
          </div>
          <div class="expand-button" v-if="schemeDoc.links.length > maxLinkDisplay"><span  @click="toggleLinks">{{showAllLinks ? "View less"  : "View all" }}</span></div>
      </div>
    </div>
  </div>
</template>

<script>
import { linkTo } from '@/assets/mixins/mixins';
import KeyInformationVideoThumbnail from '@/components/newHomepage/KeyInformationVideoThumbnail.vue';

export default {
    name: 'key-information-card',
    mixins: [linkTo],
    components: {
        KeyInformationVideoThumbnail,
    },
    props: {
        schemeDoc: Object,
        filterText: String,
        maxLinkDisplay: Number,
    },
    data () {
        return {
            showIcon: false,
            showAllLinks: false,
        };
    },
    computed: {
        showSnippet () {
            return this.schemeDoc.showSnippet === undefined || this.schemeDoc.showSnippet;
        },
        links () {
            return this.showAllLinks ? this.schemeDoc.links : this.schemeDoc.links.slice(0, this.maxLinkDisplay);
        },
        style () {
            // TODO: need to fix for ICI only FAQ - only Fund Information has a backgroundImage
            // Failed to load resource: the server responded with a status of 404 ()
            return {
                backgroundImage: `url('${this.schemeDoc.backgroundImage}')`,
            };
        },
    },
    methods: {
        toggleLinks () {
            this.showAllLinks = !this.showAllLinks;
            setTimeout(() => {
                this.$redrawVueMasonry('key-information');
            }, 0);
        },
        videoModal (videoObj) {
            this.$emit('videoModal', videoObj);
        },
    },
    watch: {
        filterText () {
            if (this.schemeDoc.links && this.schemeDoc.links.length > this.maxLinkDisplay && this.filterText.length > 2) {
                const lowerText = this.filterText.toLowerCase();
                this.schemeDoc.links.slice(this.maxLinkDisplay).map((link) => {
                    if (link.text.toLowerCase().search(lowerText) > -1) {
                        this.showAllLinks = true;
                    }
                    return null;
                });
            } else {
                this.showAllLinks = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_mixins.scss';
  .key-information-card {
      padding: 15px;
      max-width: 33.33333%;
      width: 100%;

        @include responsive("md") {
            max-width: 50%;
        }
        @include responsive("sm") {
            max-width: 100%;
            padding-left: 0;
            padding-right: 0;
        }


    .key-information-card-inner{
        box-shadow: 2px 0px 10px 2px rgba(194, 194, 194, 0.56);
        background: #ffffff;
        border-radius: 0.5rem;
        overflow: hidden;
        transition: all 300ms;
        position: relative;

        &:hover{
            transform: translateY(-3px);
            box-shadow: 2px 3px 10px 6px rgba(194, 194, 194, 0.56);
        }
    }

    .card-body{
        padding: 1.5rem;
        position: relative;
        min-height: 150px;
        background-size: 100%;
    }

    .card-links{
    padding: 1rem 1.5rem;
    background: #f7f7f7;
    margin: 0.25rem;
    width: calc(100% - 0.5rem);
    border-radius: 0 0 5px 5px;
    }

    .links-item{
        text-decoration: none;
        font-size: 15px;
        position: relative;
        display: flex;
        align-items: flex-start;

        svg{
            margin-right: 10px;
            font-size: 20px;
        }

        span{
            display: block;
        }

        &.separator:after{
            content: "";
            height: 1px;
            width: 50%;
            background: #e7e7e7;
            position: absolute;
            bottom: -10px;
            left: 50%;
            transform: translateX(-50%);
        }
    }

    .links-item:not(:last-of-type) {
        margin-bottom: 20px;
    }

    .icon{
        font-size: 2rem;
        opacity: 0.2;
        position: absolute;
        right: 1rem;
        top: 1rem;
        color: var(--iconFont);
    }

    .tile-icon-image {
      position: absolute;
      top: 0rem;
      right: 1.5rem;
      width: 4rem;
      height: 5rem;
      img {
        width: 100%;
      }
    }
    .recent-update {
      font-style: italic;
    }

    .button-holder {
      bottom: 2rem;
      width: 100%;
      .key-fund-button {
        width: 100%;
        margin: 0 auto;
        font-size: 0.9rem;
        font-weight: 700;
        padding: 10px 30px;
      }
    }
    .key-fund-heading {
      font-size: 1.3rem;
      font-weight: 700;
      max-width: 85%;
      display: inline-block;

    }

    .highlight-primary {
      color: var(--primaryColour);
    }
  }

.expand-button{
    text-align: center;
    margin-top: 15px;
    font-weight: bold;
    font-size: 14px;
    cursor: pointer;
    color: #154076;
    display: flex;
    justify-content: center;

    span{
        background:  var(--primaryColour);
        color: var(--textOnPrimary);
        padding: 5px 10px;
        border-radius: 20px;
        font-size: 10px;
        display: block;
    }
}

.main-image{
    width: 100%;
}

</style>
